/* ============
 * Unit-types Module
 * ============
 */

import actions from './actions';
import mutations from './mutations';
import state from './state';

/* eslint-disable max-len */
export default {
  namespaced: true,
  actions,
  getters: {
    unitTypes: state => state.unitTypes,
    unitTypeById: state => unitTypeId =>
      state.unitTypes.find(type => type.unit_type_id === unitTypeId),
    panoramaByUnitTypeId: state => unitTypeId =>
      state.typePanoramas[unitTypeId],
    currentUnitType: (state, getters, rootState, rootGetters) =>
      rootGetters['units/currentUnit'] &&
      getters.unitTypeById(rootGetters['units/currentUnit'].unit_type_id),
  },
  mutations,
  state,
};
